import React, { useCallback, useEffect, useRef, useState } from "react";
import {

  getPublicNews,
} from "../services/publicApi";
import { BACKEND_URL } from "../util/api";
import { Link } from "react-router-dom";

const News = ({ scroll  = false }) => {
 


  const [news, setNews] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const observerRef = useRef(null);

  /*
   * Load featured news
   */


  /*
   * Load first page of news
   */
  useEffect(() => {
    const loadNews = async () => {
      try {
        setLoading(true);
        setError(null);

        const result = await getPublicNews(1, 9);

        if (result.success) {
          setNews(result.data?.data || []);
          setCurrentPage(result.data?.current_page || 1);
          setLastPage(result.data?.last_page || 1);
        }
      } catch (err) {
        console.error("Failed to load news:", err);
        setError(err.message || "Unable to load news.");
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, []);

  /*
   * Load next page
   */
  const loadMoreNews = useCallback(async () => {
    if (loadingMore) return;

    if (currentPage >= lastPage) {
      return;
    }

    try {
      setLoadingMore(true);

      const nextPage = currentPage + 1;

      const result = await getPublicNews(
        nextPage,
        9
      );

      if (result.success) {
        const newNews = result.data?.data || [];

        setNews((previousNews) => [
          ...previousNews,
          ...newNews,
        ]);

        setCurrentPage(
          result.data?.current_page || nextPage
        );

        setLastPage(
          result.data?.last_page || lastPage
        );
      }
    } catch (err) {
      console.error("Failed to load more news:", err);
    } finally {
      setLoadingMore(false);
    }
  }, [
    currentPage,
    lastPage,
    loadingMore,
  ]);

  /*
   * Infinite scroll observer
   */
  useEffect(() => {
    const element = observerRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const firstEntry = entries[0];

        if (
          firstEntry.isIntersecting &&
          !loading &&
          !loadingMore &&
          currentPage < lastPage
        ) {
          loadMoreNews();
        }
      },
      {
        root: null,
        rootMargin: "300px",
        threshold: 0,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [
    loading,
    loadingMore,
    currentPage,
    lastPage,
    loadMoreNews,
  ]);

  /*
   * Initial loading
   */
  if (loading) {
    return (
      <section
        className="news-section section-padding"
        id="news"
        aria-labelledby="news-title"
      >
        <div className="container">
          <div className="news-loading">
            Loading news...
          </div>
        </div>
      </section>
    );
  }

  /*
   * Error state
   */
  if (error) {
    return (
      <section
        className="news-section section-padding"
        id="news"
        aria-labelledby="news-title"
      >
        <div className="container">
          <div className="news-error">
            Unable to load news at the moment.
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="news-section section-padding"
      id="news"
      aria-labelledby="news-title"
    >
      <div className="container">

        {/* SECTION HEADING */}
        <div className="section-heading">

          <div>

            <p className="section-label">
              <span />
              NEWS &amp; UPDATES
            </p>

            {/*   <h2 id="news-title">
              From the{" "}
              <em>Honourable's Office.</em>
            </h2> */}

          </div>

         { scroll === false  &&

          <Link
            to="/news"
            className="view-all"
          >
            View All News →
          </Link>

         }


        </div>

        {/* NEWS GRID */}
        <div className="news-grid">


          {/* NEWS ITEMS */}
          {news.map((item) => (
            <article
              className="news-small-card"
              key={item.id}
            >

              <div
                className={`news-small-image ${item.cover_image ? "has-image" : ""
                  }`}
                style={
                  item.cover_image
                    ? {
                      backgroundImage: `url(${BACKEND_URL + "/storage/" + item.cover_image})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      position: "relative",
                      

                    }
                    : undefined
                }
              >

                { item.cover_image  !=  null  &&
 
                <div style={{
                  position: "absolute", backgroundImage: `url(${BACKEND_URL + "/storage/" + item.cover_image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center", filter: "blur(10px)",
                  width: "100%", height: "100%",
                   opacity: 0.2
                }}>

                </div> 

              }

              </div>

              <div>

                <small>
                  {item.category?.name ||
                    "NEWS"}
                </small>

                <h3>
                  {item.title}
                </h3>

                <Link style={{ zIndex : "39293203"}}
                  to={`/news/${item.slug}`}
                >
                  Read More 
                  <span aria-hidden="true">
                    →
                  </span>
                </Link>

              </div>

            </article>
          ))}

        </div>

        

        {/* INFINITE SCROLL TRIGGER */}
        { (currentPage < lastPage  && scroll === true) && (
          <div
            ref={observerRef}
            className="news-load-more"
            aria-live="polite"
          >
            {loadingMore && (
              <>
                <span
                  className="news-spinner"
                  aria-hidden="true"
                />
                <span>
                  Loading more news...
                </span>
              </>
            )}
          </div>
        )}
      
      

        {/* END OF NEWS */}
        {currentPage >= lastPage &&
          news.length > 0 && (
            <div className="news-end">
              <span>
              {/*   You've reached the end of the news. */}
              </span>
            </div>
          )}

      </div>
    </section>
  );
};

export default News;